import { GoldTransaction } from '../types/gold';

const SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL || '';

class GoogleSheetsService {
  async getTransactions(): Promise<GoldTransaction[]> {
    try {
      const response = await fetch(SCRIPT_URL, {
        method: "GET",
        mode: "cors",
        credentials: "omit"
      });

      const data: string[][] = await response.json();

      if (!data || data.length <= 1) {
        return [];
      }

      return data.slice(1).map((row, index) => ({
        id: row[0] || `transaction-${index}`,
        date: row[1] || '',
        quantity: parseFloat(row[2]) || 0,
        pricePerChi: parseFloat(row[3]) || 0,
        totalCost: parseFloat(row[4]) || 0,
        notes: row[5] || ''
      }));
    } catch (error) {
      console.error('Error fetching transactions from Google Sheets:', error);
      return [];
    }
  }

  async addTransaction(transaction: GoldTransaction): Promise<boolean> {
    try {
      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: "cors",
        credentials: "omit",
        headers: {
           "Content-Type": "application/x-www-form-urlencoded"
        },
        body: JSON.stringify({
          values: [
            transaction.id,
            transaction.date,
            transaction.quantity,
            transaction.pricePerChi,
            transaction.totalCost,
            transaction.notes || ''
          ]
        })
      });
      console.log('Add transaction response:', response);
      const result = await response.json();
      return result.success === true;
    } catch (error) {
      console.error('Error adding transaction to Google Sheets:', error);
      return false;
    }
  }

  async deleteTransaction(id: string): Promise<boolean> {
    try {
      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: "cors",
        credentials: "omit",
         headers: {
           "Content-Type": "application/x-www-form-urlencoded"
        },
        body: JSON.stringify({ action: 'delete', id })
      });

      const result = await response.json();
      return result.success === true;
    } catch (error) {
      console.error('Error deleting transaction from Google Sheets:', error);
      return false;
    }
  }
}

export const googleSheetsService = new GoogleSheetsService();
